import { render, staticRenderFns } from "./GalleryAdd.vue?vue&type=template&id=1ce94943&scoped=true&"
import script from "./GalleryAdd.vue?vue&type=script&lang=js&"
export * from "./GalleryAdd.vue?vue&type=script&lang=js&"
import style0 from "./GalleryAdd.vue?vue&type=style&index=0&id=1ce94943&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce94943",
  null
  
)

export default component.exports